import React from "react";
import ajaxError from "../helpers/ajaxError";
import log from "../helpers/log";
import PropTypes from "prop-types";
import urljoin from "url-join";
class selectLanguage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			primary: window.other_langs.primary ? window.other_langs.primary : [],
			secondary: window.other_langs.secondary
				? window.other_langs.secondary
				: [],
			showSecondary: props.showSecondary
		};
		this.showAll = this.showAll.bind(this);
		this.goUrl = this.goUrl.bind(this);
	}

	goUrl(e) {
		window.location.href = e.target.getAttribute("data-to");
	}
	showAll(e) {
		e.preventDefault();
		window.history.pushState("", document.title, "?languages");
		this.setState({
			showSecondary: true
		});
	}
	render() {
		const linksVisibles = [];
		this.state.primary.forEach(element => {
			linksVisibles.push(
				<li key={element.iconCode}>
					<a href={element.url}>
						<span className={"flag-icon flag-icon-" + element.iconCode}> </span>
						&nbsp;{element.name}
					</a>
				</li>
			);
		});
		if (this.state.showSecondary) {
			this.state.secondary.forEach(element => {
				linksVisibles.push(
					<li key={element.iconCode}>
						{window.section === "homepage" ? (
							<a href={element.url}>
								<span className={"flag-icon flag-icon-" + element.iconCode}>
									{" "}
								</span>
								&nbsp;{element.name}
							</a>
						) : (
							<button data-to={element.url} onClick={this.goUrl}>
								<span className={"flag-icon flag-icon-" + element.iconCode}>
									{" "}
								</span>
								&nbsp;{element.name}
							</button>
						)}
					</li>
				);
			});
		}

		return (
			<div>
				<ul>{linksVisibles}</ul>
				{!this.state.showSecondary ? (
					window.section === "homepage" ? (
						<a
							onClick={this.showAll}
							href={window.location.pathname + "?languages"}
						>
							<i className="fa fa-globe" /> {translate.more_langs}
						</a>
					) : (
						<button onClick={this.showAll}>
							<i className="fa fa-globe" /> {translate.more_langs}
						</button>
					)
				) : null}
			</div>
		);
	}
}
selectLanguage.propTypes = {
	showSecondary: PropTypes.bool
};
selectLanguage.defaultProps = {
	showSecondary: false
};

export default selectLanguage;
